<template>
    <div class="card-market-jetton-percent" v-bind:class="`card-jetton-indicator--${color}`">
        <span>{{ sign }}{{ value }}%</span>
    </div>
</template>

<script>
export default {
    props: {
        change: undefined,
    },
    computed: {
        color() {
            if (this.change == null) return 'gray';
            return this.change < 0 ? 'red' : 'green';
        },
        sign() {
            if (this.change == null) return '';
            return this.change < 0 ? '−' : '+';
        },
        value() {
            const t = String(this.change);
            return t.replace(/-/g, '');
        },
    },
};
</script>

  <style lang="scss">
  .card-market-jetton-percent {
      font-size: 14px;
  }

  .card-jetton-indicator {
    &--red {
      color: var(--red-bright);
    }

    &--green {
      color: var(--green-bright);
    }

    &--gray {
      color: var(--body-muted-text-color);
    }
  }
  </style>
